/**
 * Los tipos de una solicitud de suministros, en UN solo sitio.
 *
 * ⚠ **Viven aquí y no dentro de la pantalla** por lo mismo que `Articulo` vive con el
 * formulario que lo escribe: la lista, la ficha y el formulario hablan de la misma cosa,
 * y con una definición por archivo la primera corrección del backend deja dos de las tres
 * mintiendo sin que TypeScript diga nada.
 */

import type { Unidad } from "@/componentes/inventario/FormularioArticulo"

export type EstadoSolicitud =
  | "BORRADOR"
  | "EN_APROBACION"
  | "APROBADA"
  | "RECHAZADA"
  | "ATENDIDA"
  | "ANULADA"

/**
 * Cómo se dice cada estado en pantalla.
 *
 * ⚠ **«En aprobación» y no «pendiente».** Pendiente de qué: lo que hay que saber es que
 * está en manos de quien decide, no en las de quien pidió.
 */
export const ESTADOS: Record<EstadoSolicitud, string> = {
  BORRADOR: "en borrador",
  EN_APROBACION: "en aprobación",
  APROBADA: "aprobadas",
  RECHAZADA: "rechazadas",
  ATENDIDA: "atendidas",
  ANULADA: "anuladas",
}

export type LineaSolicitud = {
  id: number
  articulo_id: number | null
  descripcion: string
  cantidad: string
  /** En qué se cuenta. El MISMO vocabulario que el depósito: ver `FormularioArticulo`. */
  unidad: Unidad
  /** `null` mientras nadie ha decidido. Al aprobar se escribe siempre. */
  cantidad_aprobada: string | null
  cantidad_entregada: string
  notas: string | null
}

export type Solicitud = {
  id: number
  codigo: string
  estado: EstadoSolicitud
  prioridad: "NORMAL" | "URGENTE"
  solicitante_id: number
  solicitante: string | null
  justificacion: string | null
  necesaria_para: string | null
  entregar_en: string | null
  enviada_en: string | null
  decidida_en: string | null
  decidida_por: number | null
  decisor: string | null
  motivo_rechazo: string | null
  /** Aprobada por quien la pidió. Se enseña, como una orden autoaprobada. */
  autoaprobada: boolean
  atendida_en: string | null
  notas_cierre: string | null
  creada_en: string
  lineas: LineaSolicitud[]
}

/** Cuánto hay en el depósito de cada renglón: lo que decide si se entrega o se compra. */
export type Disponibilidad = {
  linea_id: number
  articulo_id: number | null
  existencia: string
  costo_promedio: string
  pendiente: string
}

export type OrdenDeLaSolicitud = {
  id: number
  codigo: string
  estado: string
  monto_neto: string
}
